// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetV1Nonce (params?: {}): Promise<Dict>;
    publicGetV1Time (params?: {}): Promise<Dict>;
    publicGetV1Assets (params?: {}): Promise<List>;
    publicGetV1AssetsSymbol (params?: {}): Promise<Dict>;
    publicGetV1Markets (params?: {}): Promise<List>;
    publicGetV1MarketsSymbol (params?: {}): Promise<Dict>;
    publicGetV1HistoryMarketsSymbol (params?: {}): Promise<Dict>;
    publicGetV1MarketsSymbolOrderbookHybrid (params?: {}): Promise<Dict>;
    publicGetV1MarketsSymbolTrades (params?: {}): Promise<List>;
    publicGetV1MarketsSymbolTick (params?: {}): Promise<Dict>;
    publicGetV1MarketsSymbolCandle (params?: {}): Promise<List>;
    publicGetV1HistoryMarketsSymbolTrades (params?: {}): Promise<List>;
    publicGetV1HistoryMarketsSymbolFundingRate (params?: {}): Promise<List>;
    publicGetV1IndexPrices (params?: {}): Promise<List>;
    publicGetV1IndexPricesAssetSymbol (params?: {}): Promise<Dict>;
    publicGetV1ExpiryPricesSymbol (params?: {}): Promise<Dict>;
    publicGetV1OptionLadder (params?: {}): Promise<List>;
    publicGetV1OptionLadderSymbol (params?: {}): Promise<Dict>;
    privateGetV2Orders (params?: {}): Promise<List>;
    privateGetV2HistoryOrders (params?: {}): Promise<List>;
    privateGetV2OrdersOrderId (params?: {}): Promise<Dict>;
    privateGetV2AmmInstructions (params?: {}): Promise<List>;
    privateGetV2AmmInstructionsInstructionId (params?: {}): Promise<Dict>;
    privateGetV1WalletsTransactions (params?: {}): Promise<Dict>;
    privateGetV1WalletsLimitsSymbol (params?: {}): Promise<Dict>;
    privateGetV1WalletsDepositInstructionsCryptoSymbol (params?: {}): Promise<List>;
    privateGetV1WalletsWithdrawalInstructionsCryptoSymbol (params?: {}): Promise<List>;
    privateGetV1WalletsDepositInstructionsFiatSymbol (params?: {}): Promise<List>;
    privateGetV1WalletsWithdrawalInstructionsFiatSymbol (params?: {}): Promise<List>;
    privateGetV1WalletsSelfHostedVerificationAttempts (params?: {}): Promise<List>;
    privateGetV1Trades (params?: {}): Promise<List>;
    privateGetV1HistoryTrades (params?: {}): Promise<List>;
    privateGetV1TradesTradeId (params?: {}): Promise<Dict>;
    privateGetV1TradesClientOrderIdClientOrderId (params?: {}): Promise<List>;
    privateGetV1AccountsAsset (params?: {}): Promise<List>;
    privateGetV1AccountsAssetSymbol (params?: {}): Promise<Dict>;
    privateGetV1UsersLogout (params?: {}): Promise<Dict>;
    privateGetV1UsersHmacLogin (params?: {}): Promise<Dict>;
    privateGetV1AccountsTradingAccounts (params?: {}): Promise<List>;
    privateGetV1AccountsTradingAccountsTradingAccountId (params?: {}): Promise<Dict>;
    privateGetV1DerivativesPositions (params?: {}): Promise<List>;
    privateGetV1HistoryDerivativesSettlement (params?: {}): Promise<List>;
    privateGetV1HistoryTransfer (params?: {}): Promise<List>;
    privateGetV1HistoryBorrowInterest (params?: {}): Promise<List>;
    privateGetV2MmpConfiguration (params?: {}): Promise<Dict>;
    privateGetV2OtcTrades (params?: {}): Promise<List>;
    privateGetV2OtcTradesOtcTradeId (params?: {}): Promise<Dict>;
    privateGetV2OtcTradesUnconfirmedTrade (params?: {}): Promise<Dict>;
    privatePostV2Orders (params?: {}): Promise<Dict>;
    privatePostV2Command (params?: {}): Promise<Dict>;
    privatePostV2AmmInstructions (params?: {}): Promise<Dict>;
    privatePostV1WalletsWithdrawal (params?: {}): Promise<Dict>;
    privatePostV2UsersLogin (params?: {}): Promise<Dict>;
    privatePostV1SimulatePortfolioMargin (params?: {}): Promise<Dict>;
    privatePostV1WalletsSelfHostedInitiate (params?: {}): Promise<Dict>;
    privatePostV2MmpConfiguration (params?: {}): Promise<Dict>;
    privatePostV2OtcTrades (params?: {}): Promise<Dict>;
    privatePostV2OtcCommand (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
